
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare",
      function () {
        return require("private-next-pages/compare/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare"])
      });
    }
  